import Storage from 'repositories/Storage'

// TODO: キー名は design.md 確定後に更新
const STORAGE_KEY = 'truckbook.delivery-report.driver-session'

// 手入力で決定した納品先名を次回以降の候補に出す際の保持件数
const MANUAL_DELIVERY_DESTINATION_LIMIT = 3

const storage = Storage(STORAGE_KEY)

export const deliveryReportStorage = {
  getDriverPhone: (): string => storage.read('driver_phone') ?? '',
  getShipmentUids: (): string[] => storage.read('shipment_uids') ?? [],
  setDriverPhone: (phone: string) => storage.write('driver_phone', phone),
  appendShipmentUid: (uid: string) => {
    const uids: string[] = storage.read('shipment_uids') ?? []
    storage.write('shipment_uids', [...uids, uid])
  },
  // 手入力で決定した納品先名の履歴（新しい順・最大 MANUAL_DELIVERY_DESTINATION_LIMIT 件）
  getManualDeliveryDestinations: (): string[] => storage.read('manual_delivery_destinations') ?? [],
  // 手入力納品先を履歴の先頭に追加し、更新後の履歴を返す。
  // 同名は重複させず先頭へ繰り上げ、上限件数で打ち切る。空文字は何もせず現状の履歴を返す。
  // 呼び出し側が書き込み直後に再 read せず戻り値をそのまま使えるようにする。
  addManualDeliveryDestination: (name: string): string[] => {
    const prev: string[] = storage.read('manual_delivery_destinations') ?? []
    const trimmed = name.trim()
    if (!trimmed) return prev
    const next = [trimmed, ...prev.filter((n) => n !== trimmed)].slice(
      0,
      MANUAL_DELIVERY_DESTINATION_LIMIT
    )
    storage.write('manual_delivery_destinations', next)
    return next
  },
}
